class Questions {
    constructor() {
        this.back = $("#questions");
        this.question = $("#question");
        this.answers = [$("#a1"),$("#a2"),$("#a3")];
        this.correct = $("#congrats");
        this.fail = $("#fail");
        this.back.css({display:"none"});
        this.backgroundImage = "images/alps.jpg";
        this.current = 0;
        this.numQuestions = 0;
        this.q = null;
        this.correctOption = 0;
    }
    showQuestions() {
        var q;
        this.back.css('background-image', 'url(' + "images/"+worlds[currWorld].questionBackground + ')');
        q = this.q = wayData.questions;
        this.numQuestions = q.length;
        this.current = 0;
        this.askCurrentQuestion();
        this.back.fadeIn(400);
    }
    hide() {
        this.back.fadeOut(500);
    }
    askCurrentQuestion() {
        this.correct.css({display:"none"});
        this.fail.css({display:"none"});
        $("#a1, #a2, #a3").hide(0);
        var c = this.current;
        this.correctOption = this.q[c].a;
        var q = "Question "+(this.current+1)+" of "+this.numQuestions+" : ";
        this.question.html(q + this.q[c].q);
        var delay = 500;
        var ii = 0;
        for(var i = 0;i<3;i++) {
            this.answers[i].html(this.q[c].o[i]);
            this.answers[i].show((i+1)*400);
            this.answers[i].correct = i==this.correctOption;


            this.answers[i].off().click((i==this.correctOption) ? function() {
                this.correct.show(400);
                for(var j = 0;j<3;j++) {
                    if (!this.answers[j].correct) {
                        this.answers[j].hide(500);
                    }
                }
                setTimeout(function() {
                    this.current++;
                    if (this.current==this.numQuestions) {
                        this.win();
                        return;
                    }
                    this.askCurrentQuestion();
                }.bind(this), 3000);
            }.bind(this) : function() {
                this.fail.show(400);
                setTimeout(function() {
                    game.states.setState("VIDEO");
                    this.hide();
                }.bind(this), 3000);
            }.bind(this));
        }
    }
    win() {
        xp = 10;
        game.states.setState("WORLD");
        this.hide();
    }
}
